import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

@Pipe({
    name: 'yesNo',
    standalone: false,
})
export class YesNoPipe implements PipeTransform {
    constructor(private appTextService: AppTextService) {}

    transform(value: any, args?: any): any {
        return this.appTextService.get(value ? 'yes' : 'no');
    }
}
